var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.btnClass,attrs:{"href":_vm.href},on:{"click":function($event){$event.stopPropagation();return _vm.clickBtn($event)}}},[_vm._v("\n  "+_vm._s(_vm.btnLabel)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18005134","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components_bit/FmBtn.vue
// module id = null
// module chunks = 